{
  "AUTOMATION": {
    "HEADER": "Automatizācija",
    "DESCRIPTION": "Automatizācija var aizstāt un racionalizēt esošos procesus, kuriem nepieciešama manuāla piepūle, piemēram, etiķešu pievienošana un sarunu piešķiršana vispiemērotākajam aģentam. Tas ļauj komandai koncentrēties uz savām stiprajām pusēm, vienlaikus samazinot laiku, kas pavadīts ikdienas uzdevumiem.",
    "LEARN_MORE": "Uzzināt vairāk par automatizāciju",
    "HEADER_BTN_TXT": "Pievienot Automatizācijas Noteikumu",
    "LOADING": "Notiek automatizācijas noteikumu iegūšana",
    "ADD": {
      "TITLE": "Pievienot Automatizācijas Noteikumu",
      "SUBMIT": "Izveidot",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "FORM": {
        "NAME": {
          "LABEL": "Noteikuma Nosaukums",
          "PLACEHOLDER": "Ievadiet noteikuma nosaukumu",
          "ERROR": "Nepieciešams nosaukums"
        },
        "DESC": {
          "LABEL": "Apraksts",
          "PLACEHOLDER": "Ievadiet noteikuma aprakstu",
          "ERROR": "Nepieciešams apraksts"
        },
        "EVENT": {
          "LABEL": "Notikums",
          "PLACEHOLDER": "Lūdzu, izvēlieties vienu",
          "ERROR": "Nepieciešams notikums"
        },
        "PHASE": {
          "LABEL": "Fāze"
        },
        "ORDER": {
          "LABEL": "Secība",
          "ERROR": "Nepieciešama secība"
        },
        "CONDITIONS": {
          "LABEL": "Nosacījumi"
        },
        "ACTIONS": {
          "LABEL": "Darbības"
        }
      },
      "CONDITION_BUTTON_LABEL": "Pievienot Nosacījumu",
      "ACTION_BUTTON_LABEL": "Pievienot Darbību",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi pievienots",
        "ERROR_MESSAGE": "Nevarēja izveidot automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fāze",
        "ORDER": "Secība",
        "NAME": "Nosaukums",
        "DESCRIPTION": "Apraksts",
        "ACTIVE": "Aktīvs",
        "CREATED_ON": "Izveidots",
        "WAIT": "Gaidīšana"
      },
      "404": "Automatizācijas noteikumi nav atrasti",
      "TABS": {
        "ALL": "Visi",
        "INSTANT": "Notikuma brīdī",
        "DELAYED": "Ar aizkavi"
      },
      "WAITS": "Gaida {duration}"
    },
    "DELETE": {
      "TITLE": "Dzēst automatizācijas noteikumu",
      "SUBMIT": "Dzēst",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai vēlaties izdzēst ",
        "YES": "Jā, Dzēst ",
        "NO": "Nē, Paturēt "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Nevarēja izdzēst automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "EDIT": {
      "TITLE": "Rediģēt Automatizācijas Noteikumu",
      "SUBMIT": "Atjaunināt",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Nevarēja atjaunināt automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonēt",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācija ir veiksmīgi noklonēta",
        "ERROR_MESSAGE": "Nevarēja noklonēt automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "FORM": {
      "EDIT": "Rediģēt",
      "CREATE": "Izveidot",
      "DELETE": "Dzēst",
      "CANCEL": "Atcelt",
      "RESET_MESSAGE": "Mainot notikuma tipu tiks atiestatīti tālāk pievienotie nosacījumi un notikumi"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Lai saglabātu, Jums ir nepieciešams vismaz viens nosacījums",
      "CONTACT_CUSTOM_ATTR_LABEL": "Kontaktpersonu Pielāgotās Īpašības",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Sarunu Pielāgotās Īpašības"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Lai saglabātu, ir nepieciešama vismaz viena darbība",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Ievadiet savu ziņojumu šeit",
      "TEAM_DROPDOWN_PLACEHOLDER": "Izvēlieties komandas",
      "EMAIL_INPUT_PLACEHOLDER": "Ievadiet e-pastu",
      "URL_INPUT_PLACEHOLDER": "Ievadiet URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Izvēlieties e-pasta iesūtni un sūtītāja adresi",
      "SUBJECT_INPUT_PLACEHOLDER": "E-pasta temats",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Izvēlieties SMS iesūtni, no kuras sūtīt",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Ievadiet SMS tekstu",
      "SMS_COUNTER": "{length}/{limit} rakstzīmes, {segments} SMS (pirms mainīgo aizpildīšanas)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktivizēt Automatizācijas Noteikumu",
      "DEACTIVATION_TITLE": "Deaktivizēt Automatizācijas Noteikumu",
      "ACTIVATION_DESCRIPTION": "Šī darbība aktivizēs automatizācijas noteikumu '{automationName}'. Vai tiešām vēlaties turpināt?",
      "DEACTIVATION_DESCRIPTION": "Šī darbība deaktivizēs automatizācijas noteikumu '{automationName}'. Vai tiešām vēlaties turpināt?",
      "ACTIVATION_SUCCESFUL": "Automatizācijas Noteikums ir Veiksmīgi Aktivizēts",
      "DEACTIVATION_SUCCESFUL": "Automatizācijas Noteikums ir Veiksmīgi Deaktivizēts",
      "ACTIVATION_ERROR": "Nevarēja Aktivizēt Automatizāciju. Lūdzu, vēlāk mēģiniet vēlreiz",
      "DEACTIVATION_ERROR": "Nevarēja Deaktivizēt Automatizāciju. Lūdzu, vēlāk mēģiniet vēlreiz",
      "CONFIRMATION_LABEL": "Jā",
      "CANCEL_LABEL": "Nē"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nevarēja augšupielādēt pielikumu. Lūdzu, mēģiniet vēlreiz",
      "LABEL_IDLE": "Augšupielādēt pielikumu",
      "LABEL_UPLOADING": "Notiek augšupielāde...",
      "LABEL_UPLOADED": "Veiksmīgi Augšupielādēts",
      "LABEL_UPLOAD_FAILED": "Augšupielāde neizdevās"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Nepieciešama atribūta atslēga",
      "FILTER_OPERATOR_REQUIRED": "Nepieciešams filtra operators",
      "VALUE_REQUIRED": "Nepieciešama vērtība",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Vērtībai ir jābūt no 1 līdz 998",
      "ACTION_PARAMETERS_REQUIRED": "Nepieciešami darbības parametri",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Ir nepieciešams vismaz viens nosacījums",
      "ATLEAST_ONE_ACTION_REQUIRED": "Ir nepieciešama vismaz viena darbība"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Šī darbība darbojas tikai tad, ja noteikuma fāze ir iestatīta uz 'Pirms etiķešu piešķiršanas'.",
      "SKIP_AUTO_LABELING": "Šī darbība darbojas tikai tad, ja noteikuma fāze ir iestatīta uz 'Pirms etiķešu piešķiršanas'.",
      "MOVE_CONVERSATION_TO_INBOX": "Uz e-pasta iesūtni var pārvietot tikai e-pasta un tīmekļa tērzēšanas sarunas, turklāt tērzēšanu tikai tad, ja kontaktam ir e-pasta adrese. Pretējā gadījumā saruna paliek savā vietā, un tā vietā tiek pievienota privāta piezīme.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Sāk jaunu sarunu ar kontaktu izvēlētajā e-pasta iesūtnē, nosūta tam ziņojumu pa e-pastu un atzīmē sarunu kā atrisinātu. Tas notiek katru reizi, kad tiek izpildīts noteikums. Ja kontaktam nav e-pasta adreses, nekas netiek nosūtīts un tā vietā tiek pievienota privāta piezīme.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Sāk jaunu sarunu ar kontaktu izvēlētajā SMS iesūtnē, nosūta tam ziņojumu kā SMS un atzīmē sarunu kā atrisinātu. Tas notiek katru reizi, kad tiek izpildīts noteikums. Ziņojums ir vienkāršs teksts bez pielikumiem. Ja kontaktam nav tālruņa numura, nekas netiek nosūtīts un tā vietā tiek pievienota privāta piezīme."
    },
    "NOTICES": {
      "AI_PROMPT": "Par katru atsevišķu izvērtējumu tiek piemērota maksa.",
      "INCOMING_MESSAGES_COUNT": "Tas attiecas uz ienākošo ziņojumu skaitu sarunā.",
      "OUTGOING_MESSAGES_COUNT": "Tas attiecas uz izejošo ziņojumu skaitu sarunā."
    },
    "PHASE": {
      "BEFORE_LABELING": "Pirms etiķešu piešķiršanas",
      "AFTER_LABELING": "Pēc etiķešu piešķiršanas"
    },
    "NONE_OPTION": "Nav",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Jā",
      "NO": "Nē"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram tiešā ziņa",
      "FACEBOOK_COMMENT": "Facebook komentārs"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Saruna Izveidota",
      "CONVERSATION_UPDATED": "Saruna Atjaunināta",
      "MESSAGE_CREATED": "Ziņojums Izveidots",
      "CONVERSATION_OPENED": "Saruna Atvērta",
      "CONVERSATION_RESOLVED": "Saruna Atrisināta",
      "PHONE_CALL_FINISHED": "Zvans Beidzies"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Piešķirt Aģentam",
      "ASSIGN_TEAM": "Piešķirt Komandu",
      "ADD_LABEL": "Pievienot Etiķeti",
      "REMOVE_LABEL": "Noņemt Etiķeti",
      "SEND_EMAIL_TO_TEAM": "Sūtīt E-pastu Komandai",
      "SEND_EMAIL_TRANSCRIPT": "Nosūtīt Sarunas Transkriptu pa E-pastu",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Nosūtīt Detalizētu Sarunas Transkriptu pa E-pastu",
      "MUTE_CONVERSATION": "Apklusināt Sarunu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "RESOLVE_CONVERSATION": "Atrisināt Sarunu",
      "OPEN_CONVERSATION": "Atvērt Sarunu",
      "SEND_WEBHOOK_EVENT": "Sūtīt Webhook Notikumu",
      "SEND_ATTACHMENT": "Sūtīt Pielikumu",
      "SEND_MESSAGE": "Sūtīt Ziņojumu",
      "ADD_NOTE": "Pievienot Piezīmi",
      "CHANGE_PRIORITY": "Mainīt Prioritāti",
      "ADD_SLA": "Pievienot SLA",
      "SKIP_AUTO_PRIORITY": "Izlaist Automātisko Prioritāti",
      "SKIP_AUTO_LABELING": "Izlaist Automātisko Etiķešu Piešķiršanu",
      "AUTO_TRANSLATE": "Tulkot Ziņojumu",
      "AUTO_TRANSLATE_CONVERSATION": "Tulkot Sarunu",
      "MOVE_CONVERSATION_TO_INBOX": "Pārvietot sarunu uz iesūtni",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Sūtīt ziņojumu jaunā sarunā",
      "SEND_SMS_IN_NEW_CONVERSATION": "Sūtīt SMS jaunā sarunā",
      "STOP_PROCESSING_RULES": "Apturēt Noteikumu Apstrādi"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI Filtrs",
      "MESSAGE_TYPE": "Ziņojuma Tips",
      "MESSAGE_CONTAINS": "Ziņojuma Saturs",
      "EMAIL": "Kontaktpersonas e-pasts",
      "INBOX": "Iesūtne",
      "CHANNEL_TYPE": "Iesūtnes Tips",
      "CONVERSATION_LANGUAGE": "Sarunas Valoda",
      "PHONE_NUMBER": "Tālruņa Numurs",
      "STATUS": "Statuss",
      "BROWSER_LANGUAGE": "Pārlūkprogrammas Valoda",
      "MAIL_SUBJECT": "E-pasta Tēma",
      "COUNTRY_NAME": "Valsts",
      "MARKETPLACE_COUNTRY": "Mārketpleisa valsts",
      "REFERER_LINK": "Atsauces Saite",
      "ASSIGNEE_NAME": "Piešķirtais Aģents",
      "TEAM_NAME": "Komanda",
      "PRIORITY": "Prioritāte",
      "CALL_DIRECTION": "Zvana Virziens",
      "MISSED_CALL": "Neatbildēts Zvans",
      "MISSED_CALL_COUNT": "Neatbildēto zvanu skaits",
      "MESSAGE_SOURCE_TYPE": "Ziņojuma Avota Tips",
      "INCOMING_MESSAGE_COUNT": "Ienākošo ziņojumu skaits",
      "OUTGOING_MESSAGE_COUNT": "Izejošo ziņojumu skaits",
      "LABEL": "Etiķete",
      "EMAIL_RECIPIENTS": "E-pasta Saņēmējs",
      "EMAIL_AUTO_REPLY": "E-pasts ir automātiska atbilde",
      "ATTACHMENT_EXTENSION": "Pielikuma Paplašinājums",
      "EXTENSION": "Izsauktais Iekšējais Numurs",
      "WORKING_HOURS": "Darba laikā",
      "AGENT_REPLIED": "Aģents ir atbildējis kopš statusa maiņas"
    },
    "WAIT": {
      "RUN_LABEL": "Izpildīt darbības",
      "INSTANT": "Notikuma brīdī",
      "DELAYED": "Ar aizkavi",
      "TRIGGER_LABEL": "Gaidīt, līdz",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Saruna paliek statusā",
        "CUSTOMER_UNRESPONSIVE": "Klients neatbild aģentam",
        "AGENT_UNRESPONSIVE": "Klients nesaņem aģenta atbildi"
      },
      "STATUS_LABEL": "Statuss",
      "STATUSES": {
        "OPEN": "Atvērta",
        "PENDING": "Gaida",
        "SNOOZED": "Atlikta",
        "RESOLVED": "Atrisināta"
      },
      "DELAY_LABEL": "Gaidīšanas laiks",
      "DELAY_ERROR": "Ievadiet gaidīšanas laiku no 1 minūtes līdz 30 dienām",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Darbības tiek izpildītas, kad saruna ir statusā {status} {duration}. Statusa maiņa pirms tam tās atceļ. Etiķetes, darba laiks un aģentu atbildes tiek pārbaudīti, kad gaidīšana beidzas.",
        "CUSTOMER_UNRESPONSIVE": "Darbības tiek izpildītas, kad klients {duration} nav atbildējis uz aģenta ziņu. Klienta atbilde tās atceļ; jauna aģenta ziņa sāk gaidīšanu no jauna.",
        "AGENT_UNRESPONSIVE": "Darbības tiek izpildītas, kad klients ir gaidījis {duration} bez aģenta atbildes. Aģenta atbilde tās atceļ."
      }
    }
  }
}
